import React from 'react';

const MetricCard = ({ 
  title, 
  value, 
  icon: Icon, 
  trend = null, 
  color = 'blue',
  loading = false 
}) => {
  const colorClasses = {
    blue: 'from-blue-500 to-blue-600',
    green: 'from-green-500 to-green-600',
    purple: 'from-purple-500 to-purple-600',
    orange: 'from-orange-500 to-orange-600',
  };

  const iconColorClasses = {
    blue: 'text-blue-400',
    green: 'text-green-400',
    purple: 'text-purple-400',
    orange: 'text-orange-400',
  };

  if (loading) {
    return (
      <div className="dashboard-card animate-pulse">
        <div className="flex items-center justify-between">
          <div className="space-y-2">
            <div className="h-4 bg-dark-700 rounded w-24"></div>
            <div className="h-8 bg-dark-700 rounded w-16"></div>
            {trend && <div className="h-3 bg-dark-700 rounded w-12"></div>}
          </div>
          <div className="w-12 h-12 bg-dark-700 rounded-full"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-card hover:bg-dark-700/50 transition-colors">
      <div className="flex items-center justify-between">
        <div className="space-y-2">
          <p className="text-dark-300 text-sm font-medium">{title}</p>
          <p className="text-3xl font-bold text-white">
            {typeof value === 'number' ? value.toLocaleString() : value}
          </p>
          {trend && (
            <div className="flex items-center space-x-1">
              <span className={`text-sm font-medium ${
                trend.startsWith('+') ? 'text-green-400' : 
                trend.startsWith('-') ? 'text-red-400' : 'text-dark-300'
              }`}>
                {trend}
              </span>
            </div>
          )}
        </div>
        <div className={`w-12 h-12 rounded-full bg-gradient-to-br ${colorClasses[color]} p-3 flex items-center justify-center`}>
          <Icon size={24} className="text-white" />
        </div>
      </div>
    </div>
  );
};

export default MetricCard;